<!-- Template Config Skeleton - Layout avec panneau de gauche pour la configuration -->
<div class="template-config-skeleton">
  <div class="row">
    <!-- Panneau de gauche pour la configuration -->
    <div class="col-xl-4 col-lg-5 col-md-12" *ngIf="showLeftPanel">
      <div class="card config-panel">
        <div class="card-content">
          <div class="card-body">
            <!-- Lien de retour (1 rect) -->
            <div class="back-link mb-2">
              <app-skeleton-rect 
                width="140px" 
                height="14px" 
                class="mb-1">
              </app-skeleton-rect>
            </div>

            <!-- Titre principal avec icône expand (2 rects) -->
            <div class="d-flex justify-content-between align-items-center mb-3 ms-3">
              <app-skeleton-rect 
                width="140px" 
                height="18px">
              </app-skeleton-rect>
              <app-skeleton-rect 
                width="30px" 
                height="30px" 
                class="me-2"
                [borderRadius]="'4px'">
              </app-skeleton-rect>
            </div>

            <!-- Section En-tête avec icône (2 rects) -->
            <div class="section-item d-flex justify-content-between align-items-center mb-3 ms-4">
              <app-skeleton-rect 
                width="100px" 
                height="20px"
                class="section-title-rect">
              </app-skeleton-rect>
              <app-skeleton-rect 
                width="20px" 
                height="20px" 
                class="me-2"
                [borderRadius]="'4px'">
              </app-skeleton-rect>
            </div>

            <!-- Trait de séparation après les sections -->
            <div class="sections-separator"></div>

            <!-- Section Sections avec icône (2 rects) -->
            <div class="section-item d-flex justify-content-between align-items-center mb-3 ms-4">
              <app-skeleton-rect 
                width="110px" 
                height="20px"
                class="section-title-rect">
              </app-skeleton-rect>
              <app-skeleton-rect 
                width="20px" 
                height="20px" 
                class="me-2"
                [borderRadius]="'4px'">
              </app-skeleton-rect>
            </div>

            <!-- Trait de séparation après les sections -->
            <div class="sections-separator"></div>

            <!-- Section Pied de page avec icône (2 rects) -->
            <div class="section-item d-flex justify-content-between align-items-center mb-3 ms-4">
              <app-skeleton-rect 
                width="140px" 
                height="20px"
                class="section-title-rect">
              </app-skeleton-rect>
              <app-skeleton-rect 
                width="22px" 
                height="22px" 
                class="me-2"
                [borderRadius]="'4px'">
              </app-skeleton-rect>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Panneau de droite pour la prévisualisation -->
    <div class="col-xl-8 col-lg-7 col-md-12" *ngIf="showRightPanel">
      <div class="card preview-panel">
        <div class="card-header d-flex justify-content-between align-items-center">
          <app-skeleton-rect width="80px" height="18px"></app-skeleton-rect>
          
          <!-- Section centrale avec les 3 icônes de prévisualisation -->
          <div class="preview-controls d-flex justify-content-center">
            <app-skeleton-rect 
              width="32px" 
              height="32px" 
              [borderRadius]="'8px'" 
              class="me-2">
            </app-skeleton-rect>
            <app-skeleton-rect 
              width="32px" 
              height="32px" 
              [borderRadius]="'8px'" 
              class="me-2">
            </app-skeleton-rect>
            <app-skeleton-rect 
              width="32px" 
              height="32px" 
              [borderRadius]="'8px'">
            </app-skeleton-rect>
          </div>

          <!-- Select dropdown à droite -->
          <div class="page-selector">
            <app-skeleton-rect 
              width="170px" 
              height="32px" 
              [borderRadius]="'6px'">
            </app-skeleton-rect>
          </div>
        </div>
        <div class="card-content">
          <div class="card-body p-0">
            <!-- Zone de prévisualisation principale -->
            <div class="preview-area" *ngIf="showPreview">
             

              <!-- Contenu de prévisualisation -->
              <div class="preview-content p-4">
                <!-- Simulation d'un template de page -->
                <div class="template-preview">
                  <!-- Hero section -->
                  <div class="hero-section">
                    <app-skeleton-rect 
                      width="100%" 
                      height="300px" 
                      [borderRadius]="'12px'" 
                      >
                    </app-skeleton-rect>
                    <div class="hero-content">
                      <app-skeleton-rect 
                        width="60%" 
                        height="24px" 
                        class="ms-1">
                      </app-skeleton-rect>
                      <app-skeleton-rect 
                        width="40%" 
                        height="16px" 
                        class="ms-1">
                      </app-skeleton-rect>
                      <app-skeleton-rect 
                        width="80px" 
                        height="30px" 
                        class="ms-1"
                        >
                      </app-skeleton-rect>
                    </div>
                  </div>

                  <!-- Content sections -->
                  <div class="row">
                    <ng-container *ngFor="let item of [0,1,2]">
                      <div class="col-md-4 mb-1">
                        <app-skeleton-rect 
                          width="100%" 
                          height="120px" 
                          [borderRadius]="'8px'" 
                          class="mb-3">
                        </app-skeleton-rect>
                        <app-skeleton-rect 
                          width="80%" 
                          height="16px" 
                          class="mb-2">
                        </app-skeleton-rect>
                        <app-skeleton-rect 
                          width="100%" 
                          height="12px" 
                          class="mb-1">
                        </app-skeleton-rect>
                        <app-skeleton-rect 
                          width="70%" 
                          height="12px">
                        </app-skeleton-rect>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>